import { createFileRoute } from '@tanstack/react-router';
import { DispatchDetail } from '../../../../features/sales-invoicing/DispatchDetail';

/** Owned by G23. Dispatch detail — editable while DRAFT (+ margin preview + Post),
 * read-only once POSTED with the §9.7 genealogy panel, delivery-note download and
 * "Reverse & clone to draft" (§4.1). */
export const Route = createFileRoute('/_authenticated/sales-invoicing/dispatches/$dispatchId')({
  component: DispatchDetailPage,
});

function DispatchDetailPage() {
  const { dispatchId } = Route.useParams();
  return <DispatchDetail dispatchId={dispatchId} />;
}
